import { Injectable } from '@angular/core';
import {WrappedBehaviorSubject} from "../cache/wrapped-behavior-subject";
import {NavigationStart} from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class NavigationService {

    navigationStartSubject: WrappedBehaviorSubject<NavigationStart> = new WrappedBehaviorSubject<NavigationStart>(null);

}
